import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
    const hasProcessed = useRef(false);
    const navigate = useNavigate();
    const [error, setError] = useState('');

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const params = new URLSearchParams(window.location.hash.replace('#', ''));
        const sessionId = params.get('session_id');

        const run = async () => {
            if (sessionId) {
                try {
                    const res = await fetch(`${API}/api/auth/session`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        credentials: 'include',
                        body: JSON.stringify({ session_id: sessionId }),
                    });
                    if (!res.ok) setError('No se pudo iniciar sesion con Google. Intentalo de nuevo.');
                } catch (e) {
                    setError('No se pudo iniciar sesion con Google. Intentalo de nuevo.');
                }
            } else {
                setError('No se pudo iniciar sesion con Google. Intentalo de nuevo.');
            }
            window.setTimeout(() => navigate('/admin', { replace: true }), error ? 1800 : 400);
        };
        run();
    }, [navigate, error]);

    return (
        <div className="min-h-screen bg-ink flex flex-col items-center justify-center gap-4 text-pastelcream" data-testid="auth-callback">
            {error ? (
                <p className="font-display text-lg px-6 text-center">{error}</p>
            ) : (
                <>
                    <Loader2 size={26} className="animate-spin text-pastelcream/70" />
                    <p className="font-ink text-[11px] uppercase tracking-[0.3em] text-pastelcream/60">Conectando con Google</p>
                </>
            )}
        </div>
    );
}
